export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/backButton.2f931fca.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};